export default __webpack_public_path__ + "static/media/logo2.9b5575c1.jpg";